// frontend/src/config/platformFeatures.js
// Shared source of truth for platform features — migrated from VetAssistNetwork.jsx.
// Consumers:
//  - Navbar "Platforms" dropdown  -> uses title + icon only (4 grouped columns)
//  - Platform page (/services)    -> uses all four fields (title, icon, desc, bubble)
//  - Homepage ecosystem section (VetAssistNetwork) -> uses all four fields
//
// Icons are stored as SVG path `d` strings (stroke-based, 24x24 viewBox) so this
// config stays plain JS and components render them however they need.

/** Icon path `d` strings keyed by icon name. */
export const PLATFORM_ICON_PATHS = {
  calendar: "M3.5 5h17v15h-17z M3.5 9.5h17 M8 3v3.2 M16 3v3.2",
  pulse: "M3 12h4l2-7 4 14 2-7h6",
  record: "M12 5v14 M8 9v6 M16 9v6 M4 11v2 M20 11v2",
  chart: "M4 20V10 M11 20V4 M18 20v-6 M4 20h16",
  bell: "M6 10a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6z M10 19a2 2 0 0 0 4 0",
  message: "M4 5h16v11H8l-4 4z",
  invoice: "M6 3.5h9l3.5 3.5V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1z M8 12h8 M8 15.5h8 M8 18.5h5",
  card: "M3 6.5h18v11H3z M3 10.5h18 M6.5 14.5h4",
  soap: "M6 3.5h9l3.5 3.5V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1z M9 12.2h6 M9 15.2h6",
  grid: "M4 4h7v7H4z M13 4h7v7h-7z M4 13h7v7H4z M13 13h7v7h-7z",
  history: "M12 3a9 9 0 1 0 8.5 6 M12 3v5l3 2",
  trend: "M4 17l5-6 4 3 7-9 M20 5h-4v4",
  audit: "M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4z M5 21a7 7 0 0 1 14 0",
  qr: "M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M14 14h3v3h-3z M20 14v3h-3 M17 20h3",
  shield: "M12 3.2 20.5 8v8L12 20.8 3.5 16V8L12 3.2z M9 12l2 2 4-4",
  dashboard: "M4 4h7v7H4z M13 4h7v4h-7z M13 11h7v9h-7z M4 14h7v6H4z",
  pill: "M4.9 14.1 14.1 4.9a4 4 0 1 1 5.7 5.7L10.6 19.8a4 4 0 0 1-5.7-5.7z M8 8l8 8",
  award: "M12 3l2.4 4.8L20 8.6l-4 3.9.9 5.5L12 15.4l-4.9 2.6.9-5.5-4-3.9 5.6-.8z",
  pen: "M14.5 4.5l5 5L8 21H3v-5z",
  quote: "M6 3.5h9l3.5 3.5V20a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1z M8 11.5h8 M8 15h5",
  task: "M4 5h16v15H4z M8 12l2.5 2.5L16 9",
  video: "M3 6.5h11v11H3z M14 10l6-3v10l-6-3z",
  clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v5l3.5 2",
  network: "M12 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4z M5 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4z M19 17a2 2 0 1 0 0 4 2 2 0 0 0 0-4z M12 7v3.5 M12 10.5l-5.6 5.1 M12 10.5l5.6 5.1",
  shieldLock: "M12 3.2 20.5 8v8L12 20.8 3.5 16V8L12 3.2z M9.5 12.2h5v3.6h-5z M10.6 12.2v-1.7a1.4 1.4 0 0 1 2.8 0v1.7",
  save: "M12 3.5c4.2 0 7.5 1.2 7.5 2.6s-3.3 2.6-7.5 2.6S4.5 7.5 4.5 6.1 7.8 3.5 12 3.5z M4.5 6.1V12c0 1.4 3.3 2.6 7.5 2.6s7.5-1.2 7.5-2.6V6.1 M4.5 12v5.9c0 1.4 3.3 2.6 7.5 2.6s7.5-1.2 7.5-2.6V12",
  truck: "M2 5.5h12v10H2z M14 8.5h4.5L21 11.5v4h-7z M5.5 19.5a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4z M17.5 19.5a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4z",
  sparkle:
    "M12 3l1.9 4.9L18.8 10l-4.9 1.9L12 16.8l-1.9-4.9L5.2 10l4.9-2.1z M19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9z",
  users:
    "M16 19v-1.5a4 4 0 0 0-4-4H7.5a4 4 0 0 0-4 4V19 M9.5 10a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z M20.5 19v-1.5a4 4 0 0 0-3-3.85 M15.5 3.3a3.5 3.5 0 0 1 0 6.4",
  monitor: "M3 4.5h18v12H3z M8 20.5h8 M12 16.5v4",
};

/** The 4 platform columns/groups, in display order. `icon` is one of the
 * PLATFORM_ICON_PATHS keys — used by the All Features section and available to
 * any surface that needs a group-level icon. */
export const PLATFORM_GROUPS = [
  { id: "scheduling", label: "Scheduling & Booking", icon: "calendar" },
  { id: "clinical", label: "Records & Clinical", icon: "record" },
  { id: "billing", label: "Billing & Payments", icon: "card" },
  { id: "operations", label: "Operations", icon: "dashboard" },
];

/** Per-group intro line shown above the feature cards on /platform. */
const PLATFORM_TAB_INTROS = {
  scheduling:
    "Keep your calendar full and your clients engaged — 24/7 appointment booking, automated reminders, and real-time notifications that make it easy for pet owners to stay connected.",
  clinical:
    "Speed up documentation and keep clinical records structured, searchable, and secure — from SOAP dictation to digital certificates and e-waivers.",
  billing:
    "Capture charges accurately and get paid faster with automated invoices, flexible payment processing, and instant financial reporting.",
  operations:
    "Run every branch with confidence using real-time analytics, role-based dashboards, inventory tracking, and enterprise-grade security.",
};

/**
 * The 4 tabs shown on the platform page (/platform). Labels are **copied from the
 * navbar dropdown columns** (PLATFORM_GROUPS) so both surfaces always match.
 * Tab id === group id — one source of truth for names and ordering.
 */
export const PLATFORM_TABS = PLATFORM_GROUPS.map((group) => ({
  id: group.id,
  label: group.label,
  group: group.id,
  intro: PLATFORM_TAB_INTROS[group.id],
}));

/** Helper: resolve a URL hash ("#scheduling" or "#online-booking") to a tab + feature. */
export const resolvePlatformHash = (hash) => {
  const clean = String(hash || "").replace(/^#/, "");
  if (!clean) return null;
  const feature = PLATFORM_FEATURES.find((f) => f.id === clean);
  if (feature) {
    return { tab: PLATFORM_TABS.find((t) => t.group === feature.group) ?? null, feature };
  }
  const tab = PLATFORM_TABS.find((t) => t.id === clean);
  return { tab: tab ?? null, feature: null };
};

/**
 * All platform features (original VetAssistNetwork order preserved — the homepage
 * ecosystem section renders in this order). Each carries the full set of fields:
 * title, icon, desc, bubble — plus a `group` id that maps to PLATFORM_GROUPS.
 */
export const PLATFORM_FEATURES = [
  {
    id: "online-booking",
    title: "Appointment Booking",
    icon: "calendar",
    desc: "Let pet parents book 24/7 from any device.",
    bubble: "Direct integration with Google Calendar for seamless sync.",
    group: "scheduling",
  },
  {
    id: "teleconsult",
    title: "Teleconsult",
    icon: "video",
    desc: "Run secure video consultations with pet owners from any device.",
    bubble: "Share the consult link instantly — exam notes and records update in real time.",
    group: "scheduling",
  },
  {
    id: "treatment-plan",
    title: "Treatment plan",
    icon: "pulse",
    desc: "Build step-by-step treatment plans and track each patient's progress.",
    bubble: "Attach medications, procedures, and follow-up schedules to every plan.",
    group: "scheduling",
  },
  {
    id: "recording",
    title: "Recording",
    icon: "record",
    desc: "Log every procedure with structured, searchable notes.",
    bubble: "Includes templates for common surgeries and treatments.",
    group: "clinical",
  },
  {
    id: "data-backup",
    title: "Data Backup",
    icon: "save",
    desc: "Automatic, encrypted backups keep clinic records safe and restorable.",
    bubble: "Scheduled daily backups with one-click restore for complete peace of mind.",
    group: "clinical",
  },
  {
    id: "financial-reports",
    title: "Financial Reports",
    icon: "chart",
    desc: "Live revenue insights and invoice tracking at a glance.",
    bubble: "Filter by branch, service type, or date range instantly.",
    group: "billing",
  },
  {
    id: "appointment-reminders",
    title: "Appointment Reminders",
    icon: "bell",
    desc: "Reduce no-shows with automated reminders via SMS, in-app, and email.",
    bubble: "Reach pet owners on their preferred channel up to 3 days in advance.",
    group: "scheduling",
  },
  {
    id: "client-notification",
    title: "Client Notification",
    icon: "message",
    desc: "Real-time alerts for waitlists, labs, and surgery updates.",
    bubble: "Keeps pet owners informed without overwhelming their inbox.",
    group: "scheduling",
  },
  {
    id: "automated-billing",
    title: "Automated Billing",
    icon: "invoice",
    desc: "Trigger invoices instantly after each consultation.",
    bubble: "Supports split payments and insurance claims integration.",
    group: "billing",
  },
  {
    id: "payment-processing",
    title: "Payment Processing",
    icon: "card",
    desc: "Accept local and global payments seamlessly.",
    bubble: "Supports credit cards, digital wallets, and over-the-counter cash.",
    group: "billing",
  },
  {
    id: "soap-dictation",
    title: "SOAP Dictation",
    icon: "soap",
    desc: "Structured SOAP note inputs for better clinical records.",
    bubble: "Speak directly to the system using integrated voice-to-text.",
    group: "clinical",
  },
  {
    id: "scheduling-calendar",
    title: "Scheduling calendar",
    icon: "grid",
    desc: "Drag-and-drop staff and appointment mapping.",
    bubble: "View real-time availability for multiple vets simultaneously.",
    group: "scheduling",
  },
  {
    id: "pet-history",
    title: "Pet History",
    icon: "history",
    desc: "Longitudinal health records and lab results in one view.",
    bubble: "Includes vaccination charts, medication history, and X-ray archives.",
    group: "clinical",
  },
  {
    id: "analytics",
    title: "Analytics",
    icon: "trend",
    desc: "Track growth metrics and patient retention rates.",
    bubble: "Visualizes clinic performance with interactive charts and graphs.",
    group: "operations",
  },
  {
    id: "ai-insights",
    title: "AI Insights",
    icon: "sparkle",
    desc: "AI surfaces trends and opportunities hidden in your clinic data.",
    bubble: "Flags revenue dips, booking gaps, and at-risk patients before they become problems.",
    group: "operations",
  },
  {
    id: "audit",
    title: "Audit",
    icon: "audit",
    desc: "Immutable trails for every edit and user action.",
    bubble: "Perfect for compliance checks and staff performance reviews.",
    group: "clinical",
  },
  {
    id: "qr-inventory",
    title: "QR Inventory",
    icon: "qr",
    desc: "Scan QR codes to track physical stock in real time.",
    bubble: "Automatically updates stock levels when items are sold or used.",
    group: "operations",
  },
  {
    id: "suppliers",
    title: "Suppliers",
    icon: "truck",
    desc: "Track supplier orders, deliveries, and reorder points in one place.",
    bubble: "Get notified when stock falls below minimum levels so you never run out.",
    group: "operations",
  },
  {
    id: "scan-guard",
    title: "Scan guard",
    icon: "shield",
    desc: "Security validation for every scanned file.",
    bubble: "Ensures documents are virus-free before entering the system.",
    group: "operations",
  },
  {
    id: "dashboards",
    title: "Dashboards",
    icon: "dashboard",
    desc: "Role-specific views for Vets, Admins, and Front Desk.",
    bubble: "Each role sees only the tools and data they actually need.",
    group: "operations",
  },
  {
    id: "role-based-access",
    title: "Role-Based Access",
    icon: "users",
    desc: "Granular permissions that keep every role focused on what matters.",
    bubble: "Admins control exactly what each team member can view, edit, and approve.",
    group: "operations",
  },
  {
    id: "prescriptions",
    title: "Smart Prescription",
    icon: "pill",
    desc: "Generate digital scripts with built-in safety checks.",
    bubble: "Instantly checks for drug interactions and patient allergies.",
    group: "clinical",
  },
  {
    id: "certificates",
    title: "Certificates",
    icon: "award",
    desc: "Generate verified rabies and travel certificates instantly.",
    bubble: "Pre-filled templates and one-click signing for official use.",
    group: "clinical",
  },
  {
    id: "ewaivers",
    title: "Ewaivers",
    icon: "pen",
    desc: "Template form created by the clinic with signature.",
    bubble: "Automatically saves and attaches the signed form to the patient record.",
    group: "clinical",
  },
  {
    id: "quotations",
    title: "Quotations",
    icon: "quote",
    desc: "Transparent cost estimates for quicker treatment approval.",
    bubble: "Itemized breakdown that clients can review and approve on the spot.",
    group: "billing",
  },
  {
    id: "task-management",
    title: "Task Management",
    icon: "task",
    desc: "Assign and track internal tasks with team deadlines.",
    bubble: "Get push notifications when tasks are overdue or completed.",
    group: "operations",
  },
  {
    id: "tutorials",
    title: "Tutorials",
    icon: "video",
    desc: "Interactive guides to reduce staff onboarding time.",
    bubble: "Includes video walkthroughs for every major feature.",
    group: "operations",
  },
  {
    id: "staff-attendance",
    title: "Staff Attendance",
    icon: "clock",
    desc: "Time tracking shifts and attendance logs internally.",
    bubble: "Integrates with payroll for automated salary calculations.",
    group: "operations",
  },
  {
    id: "multi-branch-management",
    title: "Multi-branch Management",
    icon: "network",
    desc: "Manage 1 to 20 clinics from a single, unified dashboard.",
    bubble: "Synchronized data across all branches with real-time updates.",
    group: "operations",
  },
  {
    id: "security",
    title: "Security",
    icon: "shieldLock",
    desc: "Enterprise-grade encryption and strict CSP protection.",
    bubble: "All data is encrypted at rest and in transit using AES-256 standards.",
    group: "operations",
  },
  {
    id: "device-management",
    title: "Device Management",
    icon: "monitor",
    desc: "Monitor and manage clinic devices — printers, scanners, and scales.",
    bubble: "Pair hardware to rooms and staff, and catch offline devices before they disrupt the day.",
    group: "operations",
  },
];

/** Helper: features belonging to a group, in source order. */
export const getPlatformFeaturesByGroup = (groupId) =>
  PLATFORM_FEATURES.filter((feature) => feature.group === groupId);
